var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "120.4 112 459.2 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.55 112c-5.5039 0.51953-10.176 5.668-10.148 11.199v313.6c0 5.8633 5.3359 11.199 11.199 11.199h436.8c5.8633 0 11.199-5.3359 11.199-11.199v-313.6c0-5.8633-5.3359-11.199-11.199-11.199h-437.85zm12.25 22.398h414.4v271.95l-98.176-120.93c-2.3281-2.8398-6.1367-4.4023-9.8008-4.0234-3.0195 0.33594-5.875 1.957-7.6992 4.375l-61.949 80.152-127.75-136.5c-2.293-2.4375-5.7422-3.7656-9.1016-3.5-2.8867 0.25781-5.6484 1.6719-7.5234 3.8477l-92.398 105zm347.2 33.602c-18.426 0-33.602 15.176-33.602 33.602 0 18.426 15.176 33.602 33.602 33.602s33.602-15.176 33.602-33.602c0-18.426-15.176-33.602-33.602-33.602z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.3764360bdc4502b68467999198bed201.svg";
export { ForwardRef as ReactComponent };